<template>






    <!-- Main content -->    
 <div class="content">


 <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">Proveedor</h1>
          </div><!-- /.col -->
          <div class="col-sm-6">
            
          </div><!-- /.col -->
        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>

    <div class="container-fluid">
       
      <div class="row">
        
<div class="col-12">
            

            <div class="card ">
              <div class="card-header">
                
                 <button type="button" @click.prevent="abrirModal('proveedor','registrar')" class="btn btn-success mb-2"><i class="fas fa-plus-square"></i>&nbsp;Nuevo</button>&nbsp;
                 <div class="form-group row">
                   <div class="col-md-6">
                     <div class="input-group">
                       <select name="" id="" class="form-control col-md-3" v-model="criterio">
                         <option value="nit">Nit</option>
                         <option value="nombre">Nombre</option>
                       </select>
                       <input type="text" class="form-control" placeholder="Buscar" v-model="buscar" @keyup.enter="listarProveedor(1,buscar,criterio)">
                       <button type="submit" class="btn btn-primary" @click.prevent="listarProveedor(1,buscar,criterio)"><i class="fa fa-search">&nbsp;Buscar</i></button>
                     </div>
                   </div>
                 </div>

               </div>
                
                
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive">
                <table  class="table table-bordered table-strined table-light">
                  <thead class="thead-dark">
                  <tr>
                    <th>No</th>
                    <th>Opciones</th>
                    <th>Nit</th>
                    <th>Nombre</th>
                    <th>Descripcion</th>
                    <th>Telefono</th>
                    <th>Estado</th>
                    
                    
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(proveedor,index) in arrayProveedor" :key="proveedor.id" >
                    <td>{{(index + 1)}}</td>
                    <td>
                       <button type="button" @click.prevent="abrirModal('proveedor','actualizar',proveedor)" class="btn btn-warning btn-sm"><i class="fas fa-edit"></i></button>&nbsp;
                      <template v-if="proveedor.condicion">
                        <button type="button" class="btn btn-danger btn-sm" @click.prevent="desactivarProveedor(proveedor.id)">
                          <i class="fas fa-trash-alt"></i>
                          </button> 
                      </template>
                      <template v-else>
                        <button type="button" class="btn btn-info btn-sm" @click.prevent="activarProveedor(proveedor.id)"><i class="far fa-thumbs-up"></i></button> 
                      </template>
                      
                    </td>
                                    
                                    <td v-text="proveedor.nit"></td>
                                    <td v-text="proveedor.nombre"></td>
                                    <td v-text="proveedor.direccion"></td>
                                    <td v-text="proveedor.telefono"></td>
                                    
                   <td>
                       <div v-if="proveedor.condicion">
                            <span class="badge badge-success"> Activo </span>
                       </div>
                       <div v-else>
                            <span class="badge badge-danger"> Desactivado </span>
                       </div>
                      
                   </td>
                 
                  </tr>
                 
                  
                  </tbody>
                  <tfoot>
                  
                  </tfoot>
                </table>
                <div class="card-footer clearfix">
                 <nav>   
                <ul class="pagination pagination-sm m-0 float-right">
                  <li class="page-item" v-if="pagination.current_page > 1">
                    <a class="page-link" href="#" @click.prevent="cambiarPagina(pagination.current_page - 1,buscar,criterio)" >&laquo;</a>
                 </li>
                  <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                    <a class="page-link" href="#" @click.prevent="cambiarPagina(page,buscar,criterio)" v-text="page"></a>
                    </li>
                  <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                    <a class="page-link" href="#" @click.prevent="cambiarPagina(pagination.current_page + 1,buscar,criterio)">&raquo;</a>
                    </li>
                </ul>
                </nav>
              </div>
            </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>






<div tabindex="-1" class="modal fade p-5" :class="{'mostrar' : modal}" >
        <div class="modal-dialog modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h4 class="modal-title" v-text="tituloModal"></h4>
              <button type="button" class="close" @click.prevent="cerrarModal()" >
                <span aria-hidden="true" class="text-white">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                  <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">

                 <div class="form-group row">
                    <label for="recipient-name" class="col-form-label">Nit:</label> 
                     <input type="text" class="form-control"   v-model="nit">
                  </div>
                 
                  <div class="form-group row">
                     <label for="message-text" class="col-form-label">Nombre:</label>
                      <input type="text" class="form-control" v-model="nombre" >
                  </div>
                  
                  <div class="form-group row">
                     <label for="message-text" class="col-form-label">Direccion:</label>
                      <input type="text" class="form-control"  v-model="direccion" >
                  </div>
                  
                  <div class="form-group row">
                     <label for="message-text" class="col-form-label">Telefono:</label>
                      <input type="text" class="form-control"  v-model="telefono" >
                  </div>
                 
                  
                   <div v-show="errorProveedor" class="form-growp row  div-error">
                       <div class="text-center text-error">
                                        <div v-for="error in errorMostrarMsjProveedor" :key="error" v-text="error">

                                        </div>
                                    </div>
                  </div>
                  </form>
                </div> 
            </div>
            <div class="modal-footer ">
              <button type="button" class="btn btn-default"  @click.prevent="cerrarModal()">Close</button>
              <button type="button" v-if="tipoAccion==1" :disabled = "deshabilitar_boton==1"  class="btn btn-primary" @click="registrarProveedor()">Guardar</button>
               <button  type="button" v-if="tipoAccion==2" class="btn btn-primary" @click.prevent="actualizarProveedor()">Actualizar</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
    


 
      <!-- /.row -->
    </div><!-- /.container-fluid -->
  
  <!-- /.content -->
</template>
<script>




export default {
  
       data (){
            return {
                proveedor_id: 0,
                nit : '',
                nombre : '',
                direccion : '',
                telefono : '',
                arrayProveedor : [],
                modal : 0,
                tituloModal : '',
                tipoAccion : 0,
                deshabilitar_boton:0,
                errorProveedor : 0,
                errorMostrarMsjProveedor : [],
                'val1':0,
                    'val2':0,
                    'val3':0,
                    'val4':0,
                pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                    
                },
                offset : 3,
                criterio : 'nombre',
                buscar : ''
            }
        },
        

  

        computed:{



            isActived: function(){
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if(!this.pagination.to) {
                    return [];
                }
                
                var from = this.pagination.current_page - this.offset; 
                if(from < 1) {
                    from = 1;
                }

                var to = from + (this.offset * 2); 
                if(to >= this.pagination.last_page){
                    to = this.pagination.last_page;
                }  

                var pagesArray = [];
                while(from <= to) {
                    pagesArray.push(from);
                    from++;
                }
                return pagesArray;             

            }
        },
        methods : { 
            listarProveedor (page,buscar,criterio){
            
                let me=this;
                 var url= '/proveedor?page=' + page + '&buscar='+ buscar + '&criterio='+ criterio;
                axios.get(url).then(function (response) {
                    var respuesta= response.data;
                    me.arrayProveedor = respuesta.proveedor.data;
                    me.pagination= respuesta.pagination;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            

            cambiarPagina(page,buscar,criterio){
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.listarProveedor(page,buscar,criterio);
            },



            registrarProveedor(){


           
                if (this.validarProveedor()){
                    return;
                }

                 
                let me = this;
                me.deshabilitar_boton=1;
                axios.post('/proveedor/registrar',{
                  
                    
                    'nit': this.nit,
                    'nombre': this.nombre,
                    'direccion': this.direccion,
                    'telefono' : this.telefono
                    
                }).then(function (response) {
                  
                    me.cerrarModal();
                    me.deshabilitar_boton=0;
                    me.listarProveedor(1,'','nombre');
                     Swal.fire({
                          position: 'top',
                          icon: 'success',
                          title: 'Datos Agregados Con Exito!',
                          showConfirmButton: false,
                          timer: 1500
                        });
                }).catch(function (error) {
                    console.log(error);
                });
            },


            actualizarProveedor(){
              
               if (this.validarProveedor()){
                    return;
                }
                
                let me = this;
                
                   
                axios.put('/proveedor/actualizar',{
                    
                  
                    'nit': this.nit,
                    'nombre': this.nombre,
                    'direccion': this.direccion,
                    'telefono' : this.telefono,
                  
                    'id': this.proveedor_id

                    
                }).then(function (response) {
                    me.cerrarModal();
                    me.listarProveedor(1,'','nombre');
                        Swal.fire({
                          position: 'top',
                          icon: 'success',
                          title: 'Datos Agregados Con Exito!',
                          showConfirmButton: false,
                          timer: 1500
                        });
                    
                }).catch(function (error) {
                    console.log(error);
                }); 
                
            },

           
           

             validarProveedor(){


               this.errorProveedor=0;
                this.errorMostrarMsjProveedor  =[];

                
                if (!this.nit){
                  this.errorMostrarMsjProveedor .push("El nit no puede estar vacío.");
                
                }
                if (!this.nombre){
                   this.errorMostrarMsjProveedor.push("El nombre no puede estar vacio.");
                  
                }
                /*
                if (!this.direccion){
                  this.errorMostrarMsjProveedor.push("La Direccion no puede estar vacío.");
               
                }

                if (!this.telefono){
                  this.errorMostrarMsjProveedor.push("El telefono no puede estar vacío.");
                
                }
                */
                

                if (this.errorMostrarMsjProveedor.length) this.errorProveedor = 1;
              
                return this.errorProveedor;
              
            },
            cerrarModal(){
                this.modal=0;
                this.tituloModal='';
                this.nit='';
                this.nombre='';
                this.direccion='';
                this.telefono='';
                this.errorProveedor=0;
                this.val1=0;
                this.val2=0;
                this.val3=0;
                this.val4=0;
                
            },
            abrirModal(modelo, accion, data = []){

            

                switch(modelo){
                    case "proveedor":
                    {
                        switch(accion){
                            case 'registrar':
                            {
                               this.modal = 1;
                                this.tituloModal = 'Registrar Proveedor';
                                this.nit='';
                                this.nombre='';
                                this.direccion='';
                                this.telefono='';
                                this.tipoAccion = 1;
                                break;
                            }
                            case 'actualizar':
                            {
                                //console.log(data);
                                this.modal=1;
                                this.tipoAccion=2;
                                this.tituloModal='Actualizar Proveedor';
                                this.proveedor_id=data['id'];
                                this.nit = data['nit'];
                                this.nombre = data['nombre'];
                                this.direccion = data['direccion'];
                                this.telefono = data['telefono'];
                    
                                break;
                            }
                        }
                    }
                }
              
            },
           
           desactivarProveedor : function(id){
              Swal.fire({
                title: 'Esta seguro/a que desea desactivar el Proveedor?',
                
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {
                if (result.value) {
                  let me = this;
                        axios.put('/proveedor/desactivar',{
                          'id': id
                        }).then(function(response){
                          me.listarProveedor(1,'','nombre');
                          Swal.fire(
                            'Desactivado!',
                            'El registro a sido desactivado con exito.',
                            'success'
                          )
                        }).catch(function(error){
                          console.log(error);
                        });

                  
                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                 
                }
              })
                },
            

               activarProveedor: function(id){

                Swal.fire({
                title: 'Esta seguro/a que desea activar Proveedor?',
                
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {
                if (result.value) {
                  let me = this;
                        axios.put('/proveedor/activar',{
                          'id': id
                        }).then(function(response){
                         me.listarProveedor(1,'','nombre');
                          Swal.fire(
                            'activado!',
                            'El registro a sido activado con exito.',
                            'success'
                          )
                        }).catch(function(error){
                          console.log(error);
                        });

                  
                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                 
                }
              })


              }

           
        },
        mounted() {
            this.listarProveedor(1,this.buscar,this.criterio);
        }
    }
</script>
<style>
.modal-content{
    width: 100% !important;
    position: absolute !important;
}

.mostrar{
    display: list-item !important;
    opacity: 1 !important;
    position: absolute !important;
    background-color: #3c29297a !important;

}

.diverror{
  display: flex;
  justify-content: center;
}

.text-error{
  color: red;
  font-weight: bold;
}

</style>
